export const VOUCHER_CREATE_FORM_ID = Symbol("voucher-create-form-id");
